<template>
  <qc-container title="优惠券管理">
    <page-request ref="table" url="/api/mgr/business/card/discount/list" :table-header="tableHeader" :expend="expend" :prop="{type:type,cardType:cardType}" :op-width="240">
      <div class="flex-cc full">
        <el-tabs v-model="activeName">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="优惠券" name="1"></el-tab-pane>
          <el-tab-pane label="折扣券" name="2"></el-tab-pane>
          <el-tab-pane label="租赁券" name="3"></el-tab-pane>
        </el-tabs>
        <div class="flex">
          <t-button @click="doEdit()">添加</t-button>
          <t-button @click="batchUpdateStatus(1)">批量启用</t-button>
          <t-button @click="batchUpdateStatus(2)">批量结束</t-button>
          <t-button @click="batchDel()">批量删除</t-button>
        </div>
      </div>
      <template #op="scope">
        <b-button v-if="scope.row.status===0" @click="doEdit(scope.row)">编辑</b-button>
        <b-button v-if="scope.row.status===1" @click="updateStatus([scope.row.id],2)">结束</b-button>
        <b-button v-if="scope.row.status===0" @click="updateStatus([scope.row.id],1)">启用</b-button>
        <b-button v-if="scope.row.status===0" @click="doDel([scope.row.id])">删除</b-button>
        <template v-if="scope.row.status===1">
          <b-button v-if="scope.row.isIndex===1" @click="updateIndex([scope.row.id],0)">下架领券中心</b-button>
          <b-button v-if="scope.row.isIndex===0" @click="updateIndex([scope.row.id],1)">上架领券中心</b-button>
        </template>
        <b-button v-if="scope.row.status===1 || scope.row.status===2" @click="toDetail(scope.row.id)">查看</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container";
import PageRequest from "/src/components/base/page-request";
import TButton from "/src/components/el/t-button";
import BButton from "/src/components/el/b-button";


export default {
  props:{
    //类型 0线上商品 1租售商品
    type:{
      type:Number,
      default:0
    }
  },
  name: 'coupon-list',
  components: {QcContainer, PageRequest, TButton, BButton},
  computed: {
    cardType(){
      if(this.activeName=="0"){
        return null;
      }else if(this.activeName=="1"){
        return 0;
      }else if(this.activeName=="2"){
        return 1;
      }else if(this.activeName=="3"){
        return 2;
      }
    }
  },
  data() {
    return {
      activeName:"0",
      tableHeader: [
        {type: "selection", label: ""},
        {prop: "name", label: "名称",minWidth:200},
        {label: "类型",renderDraw:row=>{
            return ['优惠券','折扣券','租赁券'][row['cardType']];
          },width:100},
        {label: "门店类型",renderDraw:row=>{
            return ['实体店','洗消店'][row['storeType']];
          },width:100},
        {label: "领券中心展示",renderDraw:row=>{
            return ['否','是'][row['isIndex']];
          },width: 120},
        {prop: "count", label: "发放量",width: 100},
        {prop: "receiveCount", label: "已领取",width: 100},
        {prop: "useNum", label: "已使用",width: 100},
        {label: "面额",renderDraw:row=>{
            return row.money+['元','折','天'][row.cardType];
          },width: 100},
        {label: "活动时间",renderDraw:row=>{
            return row.actTimeType==1?"长期有效":(row.startTime+"-"+row.endTime);
          },width: 180},
        {label: "使用条件",renderDraw:row=>{
            if(row.cardType==2){
              return `满${row.fullMoney}天可用${['',',指定商品',',指定门店'][row.goodsType]}`;
            }
            return `满${row.fullMoney}元可用${['',',指定商品',',指定门店'][row.goodsType]}`;
          },width: 200},
        {label: "状态",renderDraw:row=>{
            return ['待启动','进行中','已结束'][row['status']];
          },width: 100},
      ],
      expend: [
        {label: "名称", prop: "name"},
        {label: "门店类型", prop: "storeType",type:"select",options:[{"label":"实体店","value":"0"},{"label":"洗消店","value":"1"}]},
        {label: "状态", prop: "status",type:"select",options:[{"label":"待启动","value":"0"},{"label":"进行中","value":"1"},{"label":"已结束","value":"2"}]},
        {label: "有效期", start: "startTime", end: "endTime", type: "daterange"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    toDetail(id){
      this.toRouter("/index/sales/coupon/detail",{id:id});
    },
    doEdit(row) {
      this.toRouter("/index/sales/coupon/add",row?{id:row.id}:{})
    },
    doDel(ids) {
      this.msgConfirm("/api/mgr/business/card/discount/delete", {ids: ids}, () => {
        this.pageReloadData();
      });
    },
    batchUpdateStatus(status) {
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.updateStatus(ids,status);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    updateStatus(ids,status){
      this.msgConfirm("/api/mgr/business/card/discount/updateStatus",{ids:ids,status:status},()=>{
        this.pageReloadData();
      },`您是否要${['','启用','结束'][status]}所选优惠券?`)
    },
    updateIndex(ids,isIndex){
      this.msgConfirm("/api/mgr/business/card/discount/updateIndex",{ids:ids,isIndex:isIndex},()=>{
        this.pageReloadData();
      },`您是否要将所选优惠券${['下架','上架'][isIndex]}领券中心?`)
    },
    batchDel(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doDel(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>

</style>
